export function formatCurrency(value, currency, options = {}) {
  const { delimiter, format, separator, precision, unit } = window.steadyConfig.currencyFormats[currency]

  // format with a known locale just to get the parts
  // we will exchange the delimiter and decimal separator later anyway
  const formatter = new Intl.NumberFormat('en-US', {
    useGrouping: true,
    minimumFractionDigits:
      options.maximumFractionDigits === undefined ? precision : Math.min(precision, options.maximumFractionDigits),
    maximumFractionDigits: precision,
    signDisplay: 'auto',
    notation: 'standard',
    ...options
  })

  const numberParts = formatter.formatToParts(value).map(part => {
    if (part.type === 'group') {
      return delimiter
    }
    if (part.type === 'decimal') {
      return separator
    }

    return part.value
  })

  return format.replace('%n', numberParts.join('')).replace('%u', unit)
}

export function formatCurrencyCents(value, currency, options = {}) {
  return formatCurrency(value / 100, currency, options)
}
